import type React from 'react';
import { trpc } from '../../lib/trpc';
import { WineRow } from '../WineRow';

export const WishlistTab = () => {
  const { data, isLoading, error } = trpc.user.getFavorites.useQuery();

  if (isLoading) {
    return (
      <div className="flex justify-center py-12">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-700" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="text-center py-12">
        <p className="text-error">Failed to load wishlist. Please try again.</p>
      </div>
    );
  }

  const wines = data?.wines ?? [];

  if (wines.length === 0) {
    return (
      <div className="text-center py-12">
        <h3 className="text-lg font-semibold text-gray-900 mb-2">Wishlist is Empty</h3>
        <p className="text-sm text-gray-500">
          Wines you want to taste will appear here. Tap the bookmark on any wine page.
        </p>
      </div>
    );
  }

  return (
    <section>
      <h3 className="text-lg font-semibold text-gray-900 mb-4">
        Wishlist ({wines.length})
      </h3>
      <div className="border-t border-gray-200">
        {(wines as React.ComponentProps<typeof WineRow>['wine'][]).map((wine) => (
          <WineRow key={wine._id} wine={wine} />
        ))}
      </div>
    </section>
  );
};
